import { AssetMetadataV1 } from './AssetMetadataV1';

export type AssetMetadata = {
  v1?: AssetMetadataV1;
};

export const isAssetMetadata = (maybeAssetMetadata: unknown): maybeAssetMetadata is AssetMetadata =>
  (maybeAssetMetadata as AssetMetadata)?.v1 !== undefined;
